import { Component } from '@angular/core';
import { NavigationStart, Router, Event } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { VerificationModalComponent } from './components/ui/verification-modal/verification-modal.component';
import { AuthService } from './services/auth/auth.service';
import { ThemeService } from './services/theme/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  title = 'orbis-iot-web';
  currentRoute: string;
  verificationModal: NgbModalRef;
  isAuthLoading = true; // Estado de carga de autenticación

  verificationModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false,
    centered : true,
  }

  constructor(
    translate: TranslateService,
    private _theme: ThemeService,
    private _router: Router,
    private _auth: AuthService,
    private _modal: NgbModal
    ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
   translate.use(navigator.language.substring(0,2));

   this._theme.setLightTheme();

   var test = document.getElementById('userDropdown');

   test?.addEventListener('click', ()=>console.log('clicked'))

   this.currentRoute = this._router.url;

   // Verificar el estado de autenticación al inicializar
   this._auth.user.subscribe(user => {
     this.isAuthLoading = false; // Se completó la verificación de auth

     if (user) {
       const currentUrl = this._router.url;
       if (!currentUrl.includes('/register') && !currentUrl.includes('/forgot') && !currentUrl.includes('/recover')) {
         if (user.emailVerified === false && !this.verificationModal) {
           this.verificationModal = this._modal.open(VerificationModalComponent, this.verificationModalOptions);
         }

         // Si hay una URL de redirección guardada, navegar ahí
         const redirectUrl = localStorage.getItem('redirectUrl');
         if (redirectUrl && (currentUrl === '/login' || currentUrl === '/')) {
           localStorage.removeItem('redirectUrl');
           this._router.navigate([redirectUrl]);
         }
       }
     }
   });

   this._router.events.subscribe((event: Event) => {
     if (event instanceof NavigationStart) {
       this.currentRoute = event.url;
     }
   });


  }

}
